import { render } from "./AssuntoForm.vue?vue&type=template&id=704d3f3c"
import script from "./AssuntoForm.vue?vue&type=script&lang=js"
export * from "./AssuntoForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__